import {
  SET_ORGANISATION_STRUCTURE,
  SET_CITIES,
  SET_DIVISIONS,
  SET_STATES,
  SET_SUB_DIVISIONS,
  //   SET_POSITIONS,
  SET_PROFESSIONS,
  SET_SPECIAL_GROUP,
  SET_MAINLINE_POSITIONS,
  SET_DUAL_POSITIONS,
  SET_ROLES,
  SET_APPOINTMENT_POSITIONS,
} from "../../actionTypes/meta/newMeta";

const INITIAL_STATE = {
  organisationStructure: {
    areas: [],
    zones: [],
    regions: [],
    chapters: [],
    districts: [],
    blocks: [],
  },
  states: [],
  cities: [],
  divisions: [],
  subDivisions: [],
  //   positions: [],
  dualPositionIds: [],
  mainlinePositionIds: [],
  profession: [],
  specialGroups: [],
  roleIds: [],
  appliedFor: [],
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ORGANISATION_STRUCTURE:
      return {
        ...state,
        organisationStructure: {
          ...state.organisationStructure,
          ...action.payload,
        },
      };
    case SET_CITIES:
      return {
        ...state,
        cities: action.payload,
      };
    case SET_STATES:
      return {
        ...state,
        states: action.payload,
      };
    case SET_DIVISIONS:
      return {
        ...state,
        divisions: action.payload,
      };
    case SET_SUB_DIVISIONS:
      return {
        ...state,
        subDivisions: action.payload,
      };
    case SET_MAINLINE_POSITIONS:
      return {
        ...state,
        mainlinePositionIds: action.payload,
      };
    case SET_DUAL_POSITIONS:
      return {
        ...state,
        dualPositionIds: action.payload,
      };
    case SET_PROFESSIONS:
      return {
        ...state,
        profession: action.payload,
      };
    case SET_SPECIAL_GROUP:
      return {
        ...state,
        specialGroups: action.payload,
      };
    case SET_ROLES:
      return {
        ...state,
        roleIds: action.payload,
      };
    case SET_APPOINTMENT_POSITIONS:
      return {
        ...state,
        appliedFor: action.payload,
      };
    default:
      return { ...state };
  }
};

export default reducer;
